export const PATH_LEARNING_ASSET_RELATIONS = [
  "primary",
  "prerequisite",
  "supplement",
  "demonstration",
  "practice",
  "assessment",
  "review",
  "reference",
] as const;

export type PathLearningAssetRelation =
  (typeof PATH_LEARNING_ASSET_RELATIONS)[number];

export type PathLearningAssetKind = "learn_course" | "learn_lesson";

export type PathLearningAssetCoverageRole =
  | "introduce"
  | "explain"
  | "demonstrate"
  | "practice"
  | "apply"
  | "assess"
  | "review"
  | "reference";

export type PathLearningAssetCourse = {
  id: string;
  slug: string;
  title: string;
  thumbnailUrl?: string | null;
  description?: string | null;
  difficultyLevel?: string | null;
  estimatedHours?: number | null;
  lessonCount?: number | null;
  completedLessonCount?: number | null;
};

export type PathLearningAssetLesson = {
  id: string;
  slug: string;
  title: string;
  duration?: number | null;
};

/**
 * Public projection consumed by the Path UI.
 *
 * The server is responsible for removing draft/unreviewed relations for
 * members and trial users. Presentation components deliberately do not try to
 * infer publication state from optional fields.
 */
export type PathLearningAsset = {
  kind: PathLearningAssetKind;
  relationType: PathLearningAssetRelation;
  coverageRole: PathLearningAssetCoverageRole;
  required: boolean;
  displayOrder: number;
  course: PathLearningAssetCourse;
  lesson?: PathLearningAssetLesson | null;
};

export type PathLearningAssetAuditStatus =
  | "linked"
  | "no_course_needed"
  | "rewrite_to_launcher"
  | "overlap_review"
  | "split_item"
  | "needs_new_item"
  | "blocked"
  | "unreviewed";

export type PathLearningAssetIndexEntry = {
  curriculumId: string;
  assets: PathLearningAsset[];
  /** Admin-only. Omitted from the public projection. */
  auditStatus?: PathLearningAssetAuditStatus | null;
};

export type CoursePathItem = {
  curriculumId: string;
  displayOrder: number;
  title: string;
  itemType: string;
  relationType: PathLearningAssetRelation;
  required: boolean;
};
